module.exports = __webpack_public_path__ + "img/og.fe7bb6b9.png";